module.exports = __webpack_public_path__ + "static/media/Banner.e1483e62.jpg";